import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  icons: { iconfont: 'mdi' },
  theme: {
    themes: {
      light: {} // keep empty so we can inject brand theme later
    }
  }
})

export default vuetify
